import Link from "next/link";
import React from "react";

export default function BreadcrumbTwo({ pages , className=""}) {
  return (
    <nav
      className={"flex  items-end  justify-between "+className}
      aria-label="Breadcrumb"
    >
      <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
        {/* <li className="inline-flex items-center">
          <Link
            href="/"
            className="inline-flex items-center text-base font-medium text-gray-700 hover:text-primary dark:text-gray-400 dark:hover:text-white"
          >
            <svg
              className="me-2.5 h-4 w-4"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="m19.707 9.293-2-2-7-7a1 1 0 0 0-1.414 0l-7 7-2 2a1 1 0 0 0 1.414 1.414L2 10.414V18a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-7.586l.293.293a1 1 0 0 0 1.414-1.414Z" />
            </svg>
            Home
          </Link>
        </li> */}
        {pages.map((page, index) => {
          return (
            <li key={index} className="">
              <div className="flex items-center justify-center gap-2">
                <Link
                  
                  href={page.pageHref || "#"}
                  className={
                    index + 1 === pages.length
                      ? " pointer-events-none overflow-hidden line-clamp-1 text-base text-primary dark:text-white font-semibold"
                      : " text-base font-medium text-gray-700 hover:text-primary dark:text-gray-400 dark:hover:text-white  "
                  }
                >
                  {page.pageName}
                </Link>
                {
                  index !== pages.length-1 &&   <svg
                  className="h-3 w-3 text-gray-400 rtl:rotate-180"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 6 10"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 9 4-4-4-4"
                  />
                </svg>
              }
              </div>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
